import type { LeadIntakePayload } from './lead-intake';

// Pedido a `public-lead-intake` para Compra Directa y Consignación (ticket #96).
//
// El auto que deja el visitante es SUYO, no de la automotora. Va en la MISMA
// llamada que el lead y la edge lo guarda dentro del lead (marca/modelo +
// `offered_vehicle`). Antes el sitio pedía el auto solo —la edge lo creaba en
// `vehicles`, donde quedaba como un auto más del inventario— y después insertaba
// el lead directo con el anon key.
//
// Con la edge anterior este mismo pedido también anda: crea el borrador y el lead
// juntos (es lo que ya hacía el modo tasador). Por eso el sitio puede salir antes
// que la edge.

export interface AutoDelCliente {
  brand_id: string;
  model_id: string | number;
  year: string;
  mileage: string;
  condition_id: string | number;
  /** Lo que pide, como lo escribió (con o sin puntos). Consignación no lo pide. */
  asking_price?: string;
}

export interface ClienteDelFormulario {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
}

export function pedidoAutoDelCliente(args: {
  clientId: number | string;
  /** LeadTypes.BUY_DIRECT o LeadTypes.BUY_CONSIGNMENT. */
  tipo: string;
  notas?: string;
  cliente: ClienteDelFormulario;
  auto: AutoDelCliente;
}): LeadIntakePayload {
  const { clientId, tipo, notas, cliente, auto } = args;
  const precio = auto.asking_price ? parseInt(auto.asking_price.replace(/\D/g, ''), 10) : NaN;

  return {
    clientId,
    // Con el email la edge encuentra al cliente que `initializeCustomer` acaba de
    // dejar creado. Los datos van igual por si no hay email: sin ellos la edge no
    // sabría de quién es el lead y respondería 400.
    email: cliente.email?.trim() || undefined,
    customer: {
      first_name: cliente.first_name,
      last_name: cliente.last_name,
      phone: cliente.phone,
    },
    lead: {
      type: tipo,
      notes: notas,
      brand_id: auto.brand_id,
      model_id: auto.model_id,
    },
    vehicle: {
      brand_id: auto.brand_id,
      model_id: auto.model_id,
      year: parseInt(auto.year, 10),
      mileage: parseInt(auto.mileage, 10),
      condition_id: auto.condition_id,
      price: Number.isFinite(precio) ? precio : null,
    },
  };
}
